import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArticleView } from '../components/ArticleView';
import { experiences } from '../data/experiences';
export function ExperienceArticle() {
  const {
    slug
  } = useParams();
  const experience = experiences.find(e => e.slug === slug);
  if (!experience) {
    return <main className="flex min-h-[70vh] flex-col items-center justify-center bg-paper px-6 text-center" data-id="element-1506" data-mp="5e8z56r74bx0">
        <h1 className="font-editorial text-[40px]" data-id="element-1507" data-mp="h0ft2uba1u6">This moment is no longer available.</h1>
        <Link to="/#experiences" className="mt-6 text-[15px] font-medium" data-id="element-1508" data-mp="3shwyma9qgddy">
          Return to the experiences →
        </Link>
      </main>;
  }
  return <ArticleView article={experience} siblings={experiences} basePath="/experiences" backLabel="Experiences" backHref="/#experiences" moreHeading="Other moments few will ever know" freeParagraphs={1} wallAtPx={260} data-id="element-1509" data-mp="3iltvp2724apy" />;
}